import { NotificationManager } from "react-notifications"

const findPhone = (phones) => { 
    const phone = phones.find((phone)=> phone['PhoneType'] === "MOBILE")
    return phone
 }

const handleSend = (data, item, t, phones) => { 
    let doc_number = item?.InvoiceNumber || item?.QuoteNumber || item?.CreditNoteNumber
    let phone_number = findPhone(phones)
    if (phone_number && phone_number['PhoneCountryCode'] && phone_number['PhoneNumber']) {
        let wtsp_phone = phone_number['PhoneCountryCode'].replace("+", "")+phone_number['PhoneNumber']
        const message = encodeURIComponent(t('Hello, Here is the ') + t(data.type) + " Number " + doc_number + t(' From Company ') + data.org_name) 
        +`: %0D%0A${encodeURIComponent(data.path)} %0D%0A` +
        encodeURIComponent(t('This file will be valid for 2 weeks')); 
        const whatsappLink = `https://wa.me/${wtsp_phone}?text=${message}`;
        window.open(whatsappLink, '_blank')
    } else{
        NotificationManager.error(t("Contact doesn't have a phone number"))
    }
 }

export function WtspShare(data, item, xero, t){
    let contactPhones = item?.Contact?.Phones
    let phone_number = findPhone(contactPhones)

    if (!phone_number || phone_number === undefined || !phone_number?.PhoneCountryCode || !phone_number?.PhoneNumber){
        xero.get(`contacts/${item.Contact.ContactID}`).then((resp) =>{
            handleSend(data, item, t, resp.data.Phones)
        })
    } else {
        handleSend(data, item, t, contactPhones)
    }
}